export const ArrowLeftIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 1.5L3 6L7.5 10.5" stroke="#0A0A0A" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
